import { CurrencyDataType } from '@/api/CurrencyApi';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CURRENCIES_SYMBOLS } from '@utils/Constants';

interface CurrencyState {
    currencyApiId?: string;
    currencyId?: number | null;
    currencyCode?: string;
    currencySymbol?: string | null;
    exchangeRate?: number | null;
    compraUsd?: number | null;
    ventaUsd?: number | null;
}

type DollarExchangeRate = {
    compra: number,
    venta: number
}

const initialState: CurrencyState = {
};

const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrency(state, action: PayloadAction<CurrencyDataType>) {
            state.currencyApiId = action.payload.id
            state.currencyId = action.payload.currency_id
            state.exchangeRate = action.payload.exchange_rate
            state.currencyApiId = action.payload.id
            if (state.currencyId) {
                state.currencySymbol = CURRENCIES_SYMBOLS[state.currencyId]
            }
        },
        setUsdExchange(state, action: PayloadAction<DollarExchangeRate>) {
            state.compraUsd = action.payload.compra
            state.ventaUsd = action.payload.venta
        }
    },
    extraReducers() {
    },
});

export const { setCurrency, setUsdExchange } = currencySlice.actions;
export default currencySlice.reducer;